<!-- 财经热点 -->
<template>
    <div class="container">
      <banner/>
    <div class="mynews">
    <!-- 导航栏 -->
    <div class="newsMenu">
      <div class="newsMenu-1">
        <ul class="newsMenu-nav">
          <a  href="/news"><li class="a-bg">最新</li></a>
          <a  href="/popular"><li>热门</li></a>
          <a  href="/flash"><li>快讯</li></a>
          <a  href="/important"><li>要闻</li></a>
        </ul>
      </div>
      <!-- <div class="search-with-logo">
          <input class="search" type="text" name="news" v-model="searchQuery" @input="change()" placeholder="请输入关键词搜索">
          <img class="search-logo" src="../../assets/search.jpg" alt="search" @click="performSearch">
      </div> -->
    </div>


      <div class="newsbody">
        <div class="newsText-body1" v-if="NewsInfo && NewsInfo.user ">
          <div class="Text-top">
            <div class="newsText-title">
            <v-card-title v-html="NewsInfo.title"></v-card-title>
          </div>
          <div >
            <button class="Text-share" @click="copyText()">分享</button>
          </div>
          </div>
          
          <div class="newsText-time">
             <div>{{ NewsInfo.user.username }}</div>
              <div><p>发布于</p></div>
               <div>{{ NewsInfo.time_since_create }}</div>
          </div>
          <div class="newsText-text">
                 <div><p v-html="NewsInfo.content"></p></div>
                 <div v-if="NewsInfo.picture" class="news-image">
                    <img :src="NewsInfo.picture" alt="">
                </div>
            </div>
        </div>
        <!-- 实时热榜 -->
        <div class="body2">
        <p class="newsTitle">实时热榜</p>
        <div class="list-span">
          <div v-for="(news,index) in News.slice(0,limit)" :key="index" >
              <v-card-actions class="list-text">
                <router-link :to="{ name: 'newsText', params: { id: news.id }}" >
                  <div class="list-text">
                    <span
                    :key="index"
                    :class="index<3?'number1':'number2'"
                    >{{ index+1 }}</span>

                    <span v-if="news.title"
                    :class="pp-hotlist"
                    >
                    <v-card-text v-html="news.title"></v-card-text>
                    </span>
                </div>
                </router-link>
              </v-card-actions>
          </div>
        </div>
        
        
      </div>
      </div>
  </div>
</div>

    
  <!-- </div> -->

  
</template>
    
    
<script >
import {
  getNewsById,
  getNews
} from '@/api/api';
import { ElMessage } from "element-plus";
import banner from '@/views/layout/components/banner.vue'
// 检查并确保 originalNews 是数组
function ensureArray(news) {
        return Array.isArray(news) ? news : [news];
      }
  
  export default {
    props:['id'],
    components: {banner},
    data() {
      return { 
        currentRoute: this.$route.name,
        routes: [
          { path: '/news', name: '最新' },
          { path: '/popular', name: '热门' },
          { path: '/flash', name: '快讯' },
          { path: '/important', name: '要闻' }
        ],
        test:"",
        searchQuery:"",
        highlightedContent:[],
        originalNews:[],
        
        News: "",
        hot_news:"",
        limit:9,

        NewsInfo: [],
      // loading: false,
      // error: "",
      baseUrl: ""
          };
        },
    computed: {
    },
    watch: {
    // 监听路由变化
    '$route'(to, from) {
      if (to.name === 'newsText' && to.params.id !== from.params.id) {
        // 如果路由名称相同且参数 id 相同，重新加载数据
        // this.fetchNewsInfo();
        window.location.reload(); // 强制页面刷新
      }
    },
  },
    methods: {
      // change(){
      //   console.log(this.searchQuery)
      // },
      change() {
        
        if (this.searchQuery.trim() === '') {
          // 输入框为空，显示原始新闻列表
          this.NewsInfo = this.originalNews;
          this.fetchNewsInfo()
        } else {
          // 输入框不为空，执行搜索逻辑
          this.performSearch();
        }
      },
      refreshPage() {
        // 刷新页面
        window.location.reload(true);
      },
      readMore(url) {
        window.open(url,'_blank');
      },

      async fetchNewsInfo() {
        try {
          const res = await getNewsById(this.id);
          if (res ) {
            this.originalNews = res;
            this.NewsInfo = this.originalNews
          } else {
            this.originalNews = [];
            this.NewsInfo = [];
          }
        } 
        catch (error) {
          console.error('Error fetching news details:', error);
          this.originalNews = [];
          this.NewsInfo = [];
        }
        // console.log(this.originalNews);
        console.log(this.NewsInfo)
      },
      
      // async fetchNewsInfo() {
      //     const res = await getNewsById(this.id);
      //     this.originalNews=res;
      //     this.NewsInfo=this.originalNews;
        // console.log(this.originalNews);
      // },

      async getInfo(){
        const res = await getNews()
        this.originalNews = res.results.map(news => ({
          id: news.id,
          title: news.title,
            content: news.content,
            // created_at: news.created_at,
            picture:news.image,
            user: {
              id: news.user.id,
              username:news.user.username,
            },
            time_since_create:news.time_since_create,
        }));
        this.News=[...this.originalNews];
        console.log(this.News);
      },


      // 搜索
      performSearch() {
        this.originalNews = ensureArray(this.originalNews);

        if (this.searchQuery.trim() === '') {
          this.NewsInfo = this.originalNews;
        } else {
          const query = this.searchQuery.trim();
          const regex = new RegExp(query, 'gi'); // 'g' 表示全局匹配，'i' 表示不区分大小写

          this.NewsInfo = this.originalNews.map(news => {
            if (regex.test(news.content)) {
              const highlightedContent = news.content.replace(regex, '<span class="highlight">$&</span>');
              return {
                ...news,
                content: highlightedContent
              };
            } else {
              return news;
            }
          });
        }
      },

      // 高亮显示文本
      highlightText() {
        this.originalNews = ensureArray(this.originalNews);
        if (!this.searchQuery) {
          this.NewsInfo = this.originalNews;
        } else {
          const query = this.searchQuery.trim();
          const regex = new RegExp(query, 'gi');

          this.NewsInfo = this.originalNews.map(news => {
            if (regex.test(news.content)) {
              const highlightedContent = news.content.replace(regex, '<span class="highlight">$&</span>');
              return {
                ...news,
                content: highlightedContent
              };
            } else {
              return news;
            }
          });
        }
      },

      // 分享
      copyText() {
      var oInput = document.createElement("input");
      oInput.value = this.baseUrl;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";
      ElMessage({
        message: "网站链接已复制!",
        type: "success"
      });
    }
  },
  created  () {
    // this.fetchNewsInfo();
    // this.getComplain();
   },
  mounted  () {
    this.fetchNewsInfo().then(() => {
      // 数据加载成功
    }).catch(error => {
      // 处理错误
      console.error('Error fetching news details:', error);
    });
    this.getInfo().then(() => {
      // 数据加载成功
    }).catch(error => {
      // 处理错误
      console.error('Error fetching company news:', error);
    });
    this.baseUrl = window.location.href;
  },
};
  

  </script>
    <style lang='scss' scoped>
    @import "../news/style/news.css";
    </style>